import React from 'react';

export interface ReaderAvatarProps {
  /** Full name — first letters of first two words become the initials. */
  name: string;
  /** Width in px. Default 56. */
  size?: number;
  /** Optional ring color (any valid CSS color or var). */
  ring?: string;
  className?: string;
}

/** Initials avatar with a deterministic background tint derived from the name.
 *  Used until/unless we have real reader photos.
 *
 *  Lightly rounded, NOT circular — headshots are portraits, and a circle mask
 *  crops the top and bottom of the frame, which is exactly where faces are. */
export const ReaderAvatar: React.FC<ReaderAvatarProps> = ({
  name,
  size = 56,
  ring,
  className,
}) => {
  const initials = (name || '')
    .split(/\s+/)
    .filter(Boolean)
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
  // Sum of char codes → hue in OKLCH. Same name always gets the same tint.
  const hue = Array.from(name || '').reduce((a, c) => a + c.charCodeAt(0), 0) % 360;

  return (
    <div
      className={className}
      aria-label={name}
      style={{
        width: size,
        height: size,
        borderRadius: 12,
        background: `oklch(0.62 0.10 ${hue})`,
        color: 'oklch(0.18 0.005 70)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'var(--hj-font-display)',
        fontWeight: 700,
        fontSize: size * 0.4,
        letterSpacing: '-0.02em',
        flexShrink: 0,
        border: ring ? `2px solid ${ring}` : 'none',
        userSelect: 'none',
      }}
    >
      {initials}
    </div>
  );
};
